import SubscriptionInit from './Component';

export default SubscriptionInit;